import React from 'react';
import PropTypes from 'prop-types';
import y from 'y4/Utils';
import Flex from 'components/common/Flex';
import { Col } from 'react-bootstrap';

const BasicCard = ({ form, panel, data, ...rest }) => {
  if (form);
  const templete = y.gpv(panel, 'option.html');
  const html = y.formatByNamedArgs(templete, data);
  return (
    <Col className="mb-4" {...rest}>
      <Flex
        direction="column"
        justifyContent="between"
        className="border rounded-1 h-100"
      >
        <div
          dangerouslySetInnerHTML={{
            __html: html
          }}
        ></div>
      </Flex>
    </Col>
  );
};

BasicCard.propTypes = {
  form: PropTypes.object,
  panel: PropTypes.object,
  data: PropTypes.object
};

export default BasicCard;
